/* EcoClean® — Panier : jauge « livraison offerte » (France) + cadeau Pro Pads. Conçu par XRC · xrc.fr (08/10/2026, MAJ 14/10/2026)
   Seuils réels des profils d'expédition Shopify au 14/10/2026 (prix HT, la boutique est en HT) :
   - profil général : livraison offerte dès 149 € HT ;
   - profil « Bidons 5 L » (liste B) : livraison offerte dès 400 € HT ;
   - profil « Volume 25 L » (liste V) : livraison offerte dès 1 200 € HT.
   Cadeau : 4 Pro Pads (variante PAD) ajoutés automatiquement dès qu'un flacon Ecoprotect® Rénovation (liste R) est au panier ;
   la remise automatique Shopify « 4 Pro Pads offerts avec Ecoprotect® Rénovation (auto) » les passe à 0 €. Retirés si plus de Rénovation.
   À mettre à jour si les profils ou l'offre changent. */
(function () {
  var G = 14900, BID = 40000, VOL = 120000;
  var PAD = 56907736285509, R = { '56982115385669': 1, '56982115352901': 1, '56982115418437': 1 };
  var B = {}, V = {};
  '57095869432133,56190571282757,58584886673733,57773056000325,57773070254405,58331180826949,57927001112901,56190572134725,56190572167493,56832296059205,57586469798213,57927001440581,57681754816837,57681890705733,57682010177861,57682290704709,57682362466629,58235949547845,58236083700037,58236112208197,58389482733893,58412873974085,59000994464069,59102690279749,59106206974277,59194216513861'.split(',').forEach(function (k) { B[k] = 1; });
  '58549874295109,58331180859717,57927001407813,56833120567621,56967286620485,56967449805125,57586469830981,57927001735493,57681754849605,57681890738501,57682010210629,57682290737477,57682362499397,58236130001221,58389483585861,58412874006853,59000994791749,59102690738501,59106216214853'.split(',').forEach(function (k) { V[k] = 1; });
  var fmt = function (c) { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); };
  var timer = null, busy = false;
  function bar(label, have, goal) {
    var pct = Math.max(4, Math.min(100, Math.round(have * 100 / goal)));
    var done = have >= goal;
    return '<div class="ec-fs-row' + (done ? ' is-done' : '') + '"><p>' + label + '</p><span class="ec-fs-track"><i style="width:' + pct + '%"></i></span></div>';
  }
  function render(c) {
    var g = 0, b = 0, v = 0, reno = false;
    (c.items || []).forEach(function (it) { var id = String(it.variant_id); if (R[id]) reno = true; if (V[id]) v += it.final_line_price; else if (B[id]) b += it.final_line_price; else g += it.final_line_price; });
    if (!c.item_count) return '';
    var h = '';
    if (reno) h += '<div class="ec-fs-row is-done ec-fs-gift"><p><b>🎁 4 Pro Pads offerts</b> avec votre Ecoprotect® Rénovation</p></div>';
    if (g > 0 || (b === 0 && v === 0)) {
      h += bar(g >= G ? '<b>✓ Livraison offerte</b> en France' + (b + v > 0 ? ' sur les petits formats' : '') : 'Plus que <b>' + fmt(G - g) + ' HT</b> pour la livraison offerte en France', g, G);
    }
    if (b > 0) {
      h += bar(b >= BID ? '<b>✓ Bidons 5 L : livraison offerte</b>' : 'Bidons 5 L : plus que <b>' + fmt(BID - b) + ' HT</b> pour la livraison offerte', b, BID);
    }
    if (v > 0) {
      h += bar(v >= VOL ? '<b>✓ Bidons 25 L : livraison offerte</b>' : 'Bidons 25 L : livraison offerte dès 1 200 € HT (plus que <b>' + fmt(VOL - v) + ' HT</b>)', v, VOL);
    }
    return h;
  }
  function refresh() {
    fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var cd = document.querySelector('cart-drawer');
      if (cd && cd.renderContents) { try { cd.renderContents({ sections: s }); return; } catch (e) {} }
      if (location.pathname === '/cart') location.reload();
    }).catch(function () {});
  }
  function gift(c) {
    if (busy) return false;
    var reno = false, padLine = null;
    (c.items || []).forEach(function (it) { if (R[String(it.variant_id)]) reno = true; if (it.variant_id === PAD && it.properties && it.properties._gift) padLine = it; });
    var hasPad = (c.items || []).some(function (it) { return it.variant_id === PAD; });
    var req = null;
    if (reno && !hasPad) req = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: PAD, quantity: 1, properties: { _gift: 'reno-pads' } }] }) });
    else if (!reno && padLine) req = fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: padLine.key, quantity: 0 }) });
    if (!req) return false;
    busy = true;
    req.then(function () { busy = false; refresh(); soon(); }).catch(function () { busy = false; });
    return true;
  }
  function apply() {
    var spots = document.querySelectorAll('cart-drawer .drawer__footer, #main-cart-footer .cart__footer, .cart__footer');
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (gift(c)) return;
      var html = render(c);
      spots.forEach(function (s) {
        var el = s.querySelector(':scope > .ec-fs');
        if (!el) { el = document.createElement('div'); el.className = 'ec-fs'; s.insertBefore(el, s.firstChild); }
        if (el.innerHTML !== html) el.innerHTML = html;
        el.hidden = !html;
      });
    }).catch(function () {});
  }
  function soon() { clearTimeout(timer); timer = setTimeout(apply, 300); }
  var css = document.createElement('style');
  css.textContent = '.ec-fs{margin:0 0 14px;padding:12px 14px;border-radius:12px;background:rgba(232,0,122,.08);border:1px solid rgba(232,0,122,.25)}.ec-fs[hidden]{display:none}.ec-fs-row+.ec-fs-row{margin-top:10px}.ec-fs p{margin:0 0 7px;font-size:13.5px;line-height:1.35;letter-spacing:0}.ec-fs-gift p{margin:0}.ec-fs b{font-weight:700}.ec-fs-track{display:block;height:6px;border-radius:99px;background:rgba(127,127,127,.25);overflow:hidden}.ec-fs-track i{display:block;height:100%;border-radius:99px;background:#E8007A;transition:width .4s ease}.ec-fs-row.is-done .ec-fs-track i{background:#1FA463}';
  document.head.appendChild(css);
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) { var t = ms[i].target; if (t.closest && t.closest('.ec-fs')) continue; if (t.closest && t.closest('cart-drawer, .cart__footer, #main-cart-footer, .drawer__footer, cart-items')) { soon(); return; } }
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', apply);
  if (document.readyState !== 'loading') apply();
  document.addEventListener('ec:cart-updated', soon);
})();
